import styles from "./FreeFrom.module.scss";

type FreefromProps = {
  freeFrom: string[];
};

function transformIngredientText(freeFromText: string) {
  return freeFromText.replace(/_/, " ");
}
export const FreeFrom = ({ freeFrom: freefrom }: FreefromProps) => {
  if (!freefrom.length) {
    return null;
  }

  return (
    <div className={styles.freeFrom}>
      <h2 className={styles.title}>Free from</h2>
      <ul className={styles.list}>
        {freefrom.map((freeFrom, index) => (
          <li key={index} className={styles.listItem}>
            {transformIngredientText(freeFrom)}
          </li>
        ))}
      </ul>
    </div>
  );
};
